import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import Banner from './Banner';
import InsideContact from './InsideContact';


class FuelingSuccess extends Component {
    omponentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <div>
                <Banner
                    headText="Fueling The Success Of Our Customers"
                    subHeadText="When our customers succeed, we have done our job"
                    subBoldText="INNOVATIVE. AFFORDABLE. PRACTICAL."
                    img="interior-1.jpg"
                />
                <div className="main-container">
                    <div className="container">
                        <div className="row">


                            <div className="col-lg-9 col-md-6 col-sm-12 margin5-0">
                                <h4>FUEL YOUR PERFORMANCE</h4>
                                <p>
                                    To be in business is to compete. Better products, faster services, it’s about being the best value to the customer. 
                                    Perform better than the rest, and you have a winning edge. Technology based solutions can fuel the business performance 
                                    boost you need to put you in the winner’s circle. You want to be the best. We can seriously help!
                                </p>
                                <br />
                                <h4>FUELING THE SUCCESS OF OUR CUSTOMERS</h4>
                                <p>
                                    At Automated Concepts, our goal is to make businesses, and their owners, successful and profitable through the development 
                                    and application of customized technology solutions. Such technologies can streamline workflow, reduce errors, cut overhead, 
                                    and open additional business opportunities that otherwise might be unavailable. To capture such goals, we proved to 
                                    ourselves that the best approach is not to just resell of-the-shelf products, but to build long-term relationships with our 
                                    clients to help them realize their full business potential. We take the time to get to know our clients, and to understand 
                                    their unique business needs and challenges. We partner with them over the long haul, working with them every day if need be, 
                                    to help make it happen. And when they succeed, we succeed. Simply put, we provide the fuel for businesses to succeed above 
                                    and beyond the competition.
                                </p>
                                <br />
                                <h4>WE DELIVER PERFORMANCE BY EXCELLING IN OURS</h4>
                                <p>
                                    We often hear marketing slogans like "exceeding customer expectations" or "delivering an outstanding customer experience" 
                                    as methods to entice new customers. But in today's fiercely competitive and rapidly changing environment, we know we have 
                                    to take the extra steps to help our clients meet or exceed their expectations in us. And well they should. Our clients work 
                                    under constant and significant pressure, and need to trust us to deliver timely and accurate results. And that is exactly 
                                    what we do. We focus on delivering products as well as experiences that result in our customers exceeding THEIR performance 
                                    goals. We have done this well enough that we have loyal clients whose relationships can be measured in decades. This is 
                                    something that just doesn't happen on its own and we truly appreciate their loyalty and confidence in us over the years, 
                                    something that continues to this day.
                                </p>
                                <br />
                            </div>

                            <InsideContact />

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(FuelingSuccess);


// WEBPACK FOOTER //
// ./src/components/FuelingSuccess.js